import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";
import { AppShell } from "./AppShell";
import { NeuCard } from "../neu/Neu";
import { useFeatures } from "../../hooks/useFeatures";
import { RequestFeatureButton } from "./RequestFeatureButton";

// Blocks a page whose feature the platform owner has not opened for this company yet.
export const FeatureGate = ({ feature, children }) => {
  const { t } = useTranslation();
  const features = useFeatures();
  if (!features._ready) return null;
  if (features[feature]) return children;

  return (
    <AppShell title={t("features.lockedTitle")} subtitle={t("features.lockedSubtitle")}>
      <NeuCard className="grid gap-3 p-8 text-center" data-testid="feature-locked">
        <Lock className="mx-auto h-8 w-8 text-primary" />
        <p className="text-base font-bold">{t(`features.names.${feature}`, { defaultValue: feature })}</p>
        <p className="text-sm text-muted-foreground">{t("features.lockedHint")}</p>
        <RequestFeatureButton feature={feature} />
      </NeuCard>
    </AppShell>
  );
};
